import React from 'react';

import styled from 'styled-components';

interface BodyContainerProps {
    children: React.ReactNode
}

const BodyContainer:React.FC<BodyContainerProps> = ({children}) => {

return(
  <Container>
    {children}
  </Container>
)

}

const Container = styled.div`
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: #faf9f3;
`;

export { BodyContainer };